__turbopack_context__.v({
  "darkModeButton": "_0lP7lW_darkModeButton",
  "errorMessage": "_0lP7lW_errorMessage",
  "facebookSigninButton": "_0lP7lW_facebookSigninButton",
  "facebookSigninIcon": "_0lP7lW_facebookSigninIcon",
  "googleSigninButton": "_0lP7lW_googleSigninButton",
  "googleSigninIcon": "_0lP7lW_googleSigninIcon",
  "lightModeButton": "_0lP7lW_lightModeButton",
  "oauthButtonContainer": "_0lP7lW_oauthButtonContainer",
  "oauthDivider": "_0lP7lW_oauthDivider",
  "oauthDividerLine": "_0lP7lW_oauthDividerLine",
  "oauthDividerText": "_0lP7lW_oauthDividerText",
});
